<div *ngIf='dataLoading' class="dataLoading">
  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
</div>
<ng-container *ngIf="!dataLoading">
  <div class="page-gate-print-report" id="element-to-print">
    <div class="page-header" *ngIf="details && details.orgReportHeader">
      <div class="logo">
        <img [src]="details.orgReportHeader.imagePath" alt="" style="width:65px;height:60px;">
      </div>
    </div>
    <div class="page-title">
      <h4>{{ 'gate_management.gate_pass' | translate }}</h4>
    </div>
    <div class="report-content" *ngIf="gatePassDetails">
      <table class="table-with-bordered">
        <tbody>
          <tr>
            <td>{{ 'gate_pass.gate_pass_no' | translate }}</td>
            <td>{{gatePassDetails.gatePassID}}</td>
            <td rowspan="10" class="qrcode_td w-25">
              <qrcode [elementType]='"img"' [margin]="2" [qrdata]="QrCode" [width]="150" [errorCorrectionLevel]="'M'"
                class="w-100 h-100"></qrcode>
            </td>
          </tr>
          <tr>
            <td>{{ 'gate_security.entry_gate' | translate }}</td>
            <td>{{gatePassDetails.planned_Gate}}</td>
          </tr>
          <tr>
            <td>{{ 'gate_pass.pass_valid_from' | translate }}</td>
            <td>{{gatePassDetails.validFrom| dateFormat:'d/MMM/y'}}</td>
          </tr>
          <tr>
            <td>{{ 'gate_pass.pass_valid_to' | translate }}</td>
            <td>{{gatePassDetails.validTo| dateFormat:'d/MMM/y'}}</td>
          </tr>
          <tr>
            <td>{{ 'gate_pass.exit_gate' | translate }}</td>
            <td>{{gatePassDetails.planned_GateOut}}</td>
          </tr>
          <tr>
            <td>{{ 'gate_security.purpose' | translate }}</td>
            <td>{{gatePassDetails.purpose}}</td>
          </tr>
          <tr>
            <td>{{ 'asn.reference' | translate }} / {{ 'stock.reason' | translate }}</td>
            <td>{{gatePassDetails.reference}}</td>
          </tr>
          <tr>
            <td>{{ 'stock.name' | translate }}</td>
            <td>{{gatePassDetails.driverName}}</td>
          </tr>
          <tr>
            <td>{{ 'administration.phone' | translate }}</td>
            <td>{{gatePassDetails.driverPhone}}</td>
          </tr>
          <tr>
            <td>{{ 'asn.planned_dock' | translate }}</td>
            <td>{{gatePassDetails.planned_Dock}}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="report-notes">
      <h4 class="title-notes">
        {{ 'inbound.notes' | translate }}
      </h4>
      <ul>
        <li>
          {{ 'gate_pass.work_should_be_done_under_direct_supervision_of_approved_competent_person' | translate }}
        </li>
        <li>
          {{ 'gate_pass.Mandatory_to_wear_personal_protective_equipment_ppe' | translate }}
        </li>
        <li>
          {{ 'gate_pass.only_authorized_vehicles_allowed_to_enter' | translate }}
        </li>
        <li>
          {{ 'gate_pass.all_the_time_safety_to_be_maintained_strictly' | translate }}
        </li>
        <li>
          {{ 'gate_pass.always_maintain_good_housekeeping_and_tidy_workmanship' | translate }}
        </li>
        <li>
          {{ 'gate_pass.always_use_proper_tools_equipment' | translate }}
        </li>
        <li>
          {{ 'gate_pass.do_not_touch_any_equipment_or_enter_room_which_is_not_related_to_your_company' | translate }}
        </li>
        <li>
          {{ 'gate_pass.any_non_compliance_may_cause_work_stoppage' | translate }}
        </li>
      </ul>
    </div>
    <div class="report-footer">
      <button mat-icon-button [matTooltip]="'reports.export_as_pdf' | translate" color="primary"
        (click)="printPageAsPdf()">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="18.006" viewBox="0 0 16 18.006">
          <path id="pdf-outline-icon"
            d="M24736.5-20001.994a1.753,1.753,0,0,1-1.771-1.727v-1.336a1.92,1.92,0,0,1-1.727-2.029v-6.379a1.913,1.913,0,0,1,1.727-2.023v-2.785a1.751,1.751,0,0,1,1.771-1.727h6.162a2.749,2.749,0,0,1,1.955.82l1.92,1.975a2.577,2.577,0,0,1,.736,1.717,1.917,1.917,0,0,1,1.729,2.023v6.379a1.925,1.925,0,0,1-1.727,2.029v1.336a1.752,1.752,0,0,1-1.77,1.727Zm-.082-1.727a.084.084,0,0,0,.082.082h9.006a.078.078,0,0,0,.08-.082v-1.334h-9.168Zm-1.732-9.744v6.379a.089.089,0,0,0,.082.092h12.465a.089.089,0,0,0,.08-.092v-6.379a.089.089,0,0,0-.08-.094h-12.465A.089.089,0,0,0,24734.684-20013.465Zm10.9-2.025a.978.978,0,0,0-.27-.578l-1.924-1.98a1.021,1.021,0,0,0-.727-.3h-6.162a.083.083,0,0,0-.082.08v2.783Zm-9.977,6.963v-3.428a.445.445,0,0,1,.131-.324.462.462,0,0,1,.328-.131h.982a1.444,1.444,0,0,1,1.471,1.416,1.445,1.445,0,0,1-1.471,1.418c-.121,0-.326,0-.516,0v1.047a.458.458,0,0,1-.467.447A.452.452,0,0,1,24735.6-20008.527Zm.926-2.467v.523c.191,0,.4-.008.516-.008a.538.538,0,0,0,.547-.516.539.539,0,0,0-.547-.516h-.516Zm7.465,2.4v-3.4a.454.454,0,0,1,.461-.453h1.416a.459.459,0,0,1,.465.453.456.456,0,0,1-.465.447h-.951v.771h.838a.459.459,0,0,1,.467.453.458.458,0,0,1-.467.447h-.838v1.285a.454.454,0,0,1-.465.447A.453.453,0,0,1,24743.994-20008.59Zm-4.3.279a.443.443,0,0,1-.137-.316s-.008-1.211-.008-1.67v-1.658a.453.453,0,0,1,.131-.324.493.493,0,0,1,.33-.131h.969a1.884,1.884,0,0,1,1.838,2.113,1.931,1.931,0,0,1-1.8,2.111c-.279.006-1,.006-1,.006A.476.476,0,0,1,24739.7-20008.311Zm.781-1.986c0,.273,0,.826.006,1.211.188,0,.393,0,.516-.006.621-.008.895-.609.895-1.205,0-.279-.061-1.213-.912-1.213h-.5Z"
            transform="translate(-24733 20020)" />
        </svg>
      </button>
      <button mat-icon-button [matTooltip]="'reports.print' | translate" color="primary" (click)="printPage()">
        <svg xmlns="http://www.w3.org/2000/svg" height="48" viewBox="0 -960 960 960" width="48">
          <path
            d="M658-648v-132H302v132h-60v-192h476v192h-60Zm-518 60h680-680Zm599 95q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm-81 313v-192H302v192h356Zm60 60H242v-176H80v-246q0-45.05 30.5-75.525Q141-648 186-648h588q45.05 0 75.525 30.475Q880-587.05 880-542v246H718v176Zm102-236v-186.215Q820-562 806.775-575 793.55-588 774-588H186q-19.55 0-32.775 13.225Q140-561.55 140-542v186h102v-76h476v76h102Z" />
        </svg>
      </button>
    </div>
  </div>
</ng-container>